var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "subheader",
    class: _vm.subheaderClasses,
    attrs: {
      "id": "kt_subheader"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap",
    class: {
      'container-fluid': _vm.widthFluid,
      container: !_vm.widthFluid
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };